import { TextStyle } from 'pixi.js'

export const bonustextStyle = new TextStyle({
  fill: 'white',
  fontSize: 32,
  wordWrap: true,
  wordWrapWidth: 750,
  lineHeight: 50,
})
export const multiplierTexrStyle = new TextStyle({
  fill: 'white',
  fontSize: 32,
  wordWrap: true,
  wordWrapWidth: 650,
  lineHeight: 50,
})
export const paragraphStyle = new TextStyle({
  fill: 'white',
  fontSize: 32,
  wordWrap: true,
  wordWrapWidth: 960,
  lineHeight: 50,
})

export const titleStyle = new TextStyle({
  fontFamily: 'Roboto',
  fill: '#ECC350',
  fontSize: 36,
  lineHeight: 45,
  wordWrapWidth: 484,
  align: 'center',
  fontWeight: 'bold',
})

export const tableTitleStyle = new TextStyle({
  fill: '#febddd',
  fontSize: 45,
  lineHeight: 45,
  fontWeight: 'bold',
})
export const icontextStyle = new TextStyle({
  fill: 'white',
  fontSize: 32,
  wordWrap: true,
  wordWrapWidth: 680,
  lineHeight: 51.2,
})
export const payTableStyle = new TextStyle({
  fill: 'white',
  fontSize: 32,
  wordWrap: true,
  wordWrapWidth: 880,
  lineHeight: 50,
})

export const payoutAmountStyle = new TextStyle({
  fill: '#febddd',
  fontWeight: '600',
  fontSize: 45,
})

export const symbolCountStyle = new TextStyle({
  fill: '#FFF',
  fontWeight: '600',
  fontSize: 45,
})
